import React from "react"
import { Link } from "gatsby"
import tagData from "../data/tags"

export default ({ slug, courseNumber, courseName, tags, wordCount }) => (
  <li className="course">
    <Link to={slug}>
      {courseNumber}: {courseName + " "}
    </Link>
  </li>
)
